export default __webpack_public_path__ + "static/media/pioneer1.249a1853.jpeg";